module.exports = __webpack_public_path__ + "static/media/twitter.ef74b3e5.svg";